// extracted by extract-css-chunks-webpack-plugin
module.exports = {"badge":"aj-card__badge--3ddG4","img":"aj-card__img--odK48","description":"aj-card__description--3kJmr","right":"aj-card__right--1NIOs","bottom":"aj-card__bottom--2-PB5"};